'use client';
import GloCart from '@/app/eflayout/GloCart';
import getLocal from 'eco-design-reliance/getLocal';
import EcoCartIconL from 'eco-design/elements/eco-cart/EcoCartIconL';
import { Fragment, useEffect, useRef, useState } from 'react';
import WidgetsArrowSvgA from '../comps/ArrowSvgA';
import getCurrentEffect from '../utils/getCurrentEffect';
import WidgetsItemBackToTop from '../widgets-items/widgets-item-BackToTop';
import WidgetsItemCart from '../widgets-items/widgets-item-cart';
import WidgetsItemEcoCreditsWin from '../widgets-items/widgets-item-EcoCreditsWin';
import EcoCreditsWinEnterA from '../widgets-items/widgets-item-EcoCreditsWin/EcoCreditsWinEnterA';
import WidgetsItemMicrosoftChat from '../widgets-items/widgets-item-MicrosoftChat';
import { openNewWidgetsLocales, OtherLocaleSettingA } from './other-locale-setting';

export default function WidgetsBottomRight({
    __globar_right_v2 = [],
    __globar_bottom_v2 = [],
    globalTimestamp,
}: {
    __globar_right_v2: any[];
    globalTimestamp: number;
    __globar_bottom_v2: any[];
}) {
    const widgetHided = true;
    const [showHiddenBtn, setShowHiddenBtn] = useState<boolean>(false);
    const widgetIn2 = useRef<any>(null);
    const { locale, pathname } = getLocal();
    const static_list_a = OtherLocaleSettingA[locale] || [];
    const __globar_right_list = openNewWidgetsLocales.includes(locale) ? __globar_right_v2 || [] : static_list_a;

    const sortRightList = __globar_right_list.sort((a, b) => b.sort - a.sort);

    useEffect(() => {
        const el = document.getElementById('Widgets-box-in2-right-id');
        if (!el) return;

        const calc = () => {
            const sortRightList2 = sortRightList.filter((item: any) => {
                const flagA1 = item.enable;
                const flagA2 = getCurrentEffect(item, pathname);
                const flagA3 = item.widgetType !== 'SHOPPING_CART';
                return flagA1 && flagA2 && flagA3;
            });
            const count = sortRightList2.length + el.children.length;

            setShowHiddenBtn(count >= 2);
        };

        calc(); // 初始化

        const observer = new MutationObserver(calc);

        observer.observe(el, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, [sortRightList, pathname]);

    return (
        <section className="WidgetsBottomRight" id="widgetBottomRight">
            <div className="WidgetsBottomRight-inner">
                <div className="Widgets-box-in1">
                    <WidgetsItemBackToTop />
                    <div className="Widgets-box-in2" id="Widgets-box-in2-right-id"></div>
                    {sortRightList.map((itemA: any, index: number) => {
                        const widgetType = itemA.widgetType || '';
                        const isOpen_MicrosoftChatItemA = widgetType === 'CHAT'; //客服聊天
                        const isOpen_SHOPPING_CART = widgetType === 'SHOPPING_CART'; //购物车
                        const isOpen_MEMBER = widgetType === 'MEMBER'; //会员
                        const bottom_Chat = __globar_bottom_v2?.length > 0 ? __globar_bottom_v2[0] : {};
                        const isOpenBottomChat = bottom_Chat.enable && getCurrentEffect(bottom_Chat, pathname);
                        const isOpenInPathname = openNewWidgetsLocales.includes(locale) ? getCurrentEffect(itemA, pathname) : true;

                        return (
                            <Fragment key={index}>
                                {isOpen_MicrosoftChatItemA && isOpenInPathname && !isOpenBottomChat && (
                                    <>
                                        <WidgetsItemMicrosoftChat position="right" microsoftChatItemA={itemA} rightIconUrl={itemA.widgetIcon} />
                                    </>
                                )}
                                {isOpen_SHOPPING_CART && (
                                    <>
                                        <div className="WidgetsItem WidgetsItem-GloCart">
                                            <EcoCartIconL iconUrl={itemA.widgetIcon} />
                                            <GloCart systemTimestamp={globalTimestamp} />
                                        </div>
                                    </>
                                )}
                                {isOpen_MEMBER && isOpenInPathname && (
                                    <>
                                        <WidgetsItemEcoCreditsWin iconUrl={itemA.widgetIcon} />
                                    </>
                                )}
                            </Fragment>
                        );
                    })}
                </div>
            </div>
            <WidgetsItemCart systemTimestamp={globalTimestamp} iconUrl={''} />
            <EcoCreditsWinEnterA />
            {showHiddenBtn && <WidgetsArrowSvgA />}
        </section>
    );
}
